// Biteship "Tipe Layanan": diturunkan dari data rates aktual (courier_service_category = service_type Biteship).
// Tidak ada daftar layanan hardcoded; label hanya pemetaan tampilan dengan fallback nilai mentah.
const LABELS = {
  instant: "Instan", same_day: "Same Day", next_day: "Next Day", regular: "Reguler", standard: "Reguler",
  express: "Express", overnight: "Overnight", economy: "Ekonomi", cargo: "Kargo", trucking: "Trucking",
};

export function serviceTypeLabel(code) {
  const c = String(code || "").toLowerCase();
  return LABELS[c] || c.replace(/_/g, " ").replace(/\b\w/g, (m) => m.toUpperCase());
}

export function biteshipServiceTypes(rates) {
  const seen = new Set();
  const out = [];
  for (const r of rates || []) {
    const c = r?.courier_service_category ? String(r.courier_service_category).toLowerCase() : null;
    if (c && !seen.has(c)) { seen.add(c); out.push({ code: c, label: serviceTypeLabel(c) }); }
  }
  return out;
}

export function filterRatesByServiceType(rates, code) {
  if (!code) return rates || [];
  return (rates || []).filter((r) => String(r?.courier_service_category || "").toLowerCase() === code);
}

// Filter yang tidak lagi tersedia pada rates baru (alamat/keranjang berubah) harus di-reset ke "Semua".
export function reconcileServiceTypeFilter(rates, code) {
  return code && biteshipServiceTypes(rates).some((t) => t.code === code) ? code : "";
}
